import { PropsWithChildren, ReactNode } from "react"

import { Stack } from "@/generated/material"

import { TopBar, TopBarProps } from "../components/utils"
import { ChildRoute, LayoutContainer } from "./LayoutContainer"

interface Props {
  back?: TopBarProps["back"]
  header: ReactNode
  routePattern: string
  childRoutes?: ChildRoute[]
  "data-testid": string
}

export const SimpleViewLayout = ({
  back,
  header,
  routePattern,
  childRoutes,
  children,
  "data-testid": testId,
}: PropsWithChildren<Props>) => (
  <LayoutContainer
    routePattern={routePattern}
    childRoutes={childRoutes}
    data-testid={testId}
  >
    <Stack padding="lg" paddingTop={back ? "lg" : "none"} gap="3xl">
      {back && <TopBar back={back} />}
      <Stack paddingTop={back == null ? "5xl" : "none"} gap="md">
        {header}

        {children}
      </Stack>
    </Stack>
  </LayoutContainer>
)
